import { Container } from 'modules/Sty';
import { Caption } from './Typography';
import Colors from "modules/Colors";
import Icon from 'elements/Icon';
import { clsx } from 'modules/Utils';

const MaestroBadge = ({
    className = '',
    showVersionTag: showVersionTag = true,
    subtitle = '',
}: {
    className?: string,
    showVersionTag?: boolean,
    subtitle?: string,
}) => {
    return (
        <Container
            className={clsx('maestroBadgeComponent', className)}
            backgroundColor="#F5EBFF"
            display="flex"
            borderRadius="8px"
            flexDirection="row"
            justifyContent="center"
            alignItems="center"
            padding="2px 6px"
            gap="4px"
            width="fit-content"
        >
            <Icon
                className="maestroBadgeImageIcon"
                icon="maestroBadgeImage"
                size={24}
            />
            <Caption color={Colors.textColor}>Maestro AI{subtitle && ` ${subtitle}`}</Caption>
            {showVersionTag &&
                <div
                    className="maestroBadgeBetaTag"
                    style={{
                        backgroundColor: "#2C2135",
                        borderRadius: 100,
                        textTransform: 'uppercase',
                        padding: '0px 6px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Caption color={Colors.textColorWhite}>
                        1.0
                    </Caption>
                </div>
            }
        </Container>
    )
}

export default MaestroBadge;